/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/react-in-jsx-scope */
import { Box, Grid } from "@mui/material";
import { Formik } from "formik";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import InputField from "../../../components/common/new/InputField/InputField";
import { MEMBER_PROFILE_CREATE } from "../../../contants/formFields";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { getOptions } from "../../../utils";
import { REGEX } from "../../../utils/validation/regex";
import Button from "../../../components/common/Button";
import { selectFriendProfile } from "../../../redux/selectors/friend";
import IntroductionForm from "../../../services/api/introductionForm";
import Styles from "./styles";
import { debounce, getSubDivisionDisplayName } from "../../../utils/helper";
import Friends from "../../../services/api/friend";
import { AlertStatus } from "../../../contants";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Typography from "../../../components/common/new/Typography/Typography";
import { selectAllSIUsers } from "../../../redux/selectors/user";

export const getGohonzonType = (type) => {
  return type ? type.split("_")[0] : "";
};

function ProfileForm({
  values,
  handleChange,
  errors,
  setFieldValue,
  setCities,
  states,
  cities,
  countries,
  divisions,
  subDivisions,
  setSubDivisions,
  // friendProfile,
  profession,
  // enableIsEdit,
  // hasPermission,
  district,
  block,
  isDistrictSi,
  isChapterSi,
  isHelpDesk,
  isHelpDeskAdmin,
}) {
  // const [toggle, settoggle] = useState(false);
  const navigate = useNavigate();

  // const introducerName = friendProfile.introducerName?.length
  //   ? friendProfile.introducerName.split("-")[0]
  //   : "";

  const onCancel = () => {
    navigate(-2);
  };

  return (
    <Box>
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={5.5}>
              {/* <InputField
                label="Full Name"
                placeholder="Full Name.."
                name={MEMBER_PROFILE_CREATE.NAME}
                value={values[MEMBER_PROFILE_CREATE.NAME]}
                onChange={handleChange}
                // disabled={!hasPermission(PERMISSIONS.UPDATE_MEMBER_NAME)}
                // disabled
              /> */}
              <InputField
                label="Full Name"
                placeholder="Full Name.."
                name={MEMBER_PROFILE_CREATE.NAME}
                value={values[MEMBER_PROFILE_CREATE.NAME] || ""}
                onChange={(e) => {
                  const { value } = e.target;
                  // OLD (kept for future reference): const regex = /^[A-Za-z ]*$/;
                  const regex = REGEX.NAME_ALPHA_SPACE;

                  if (regex.test(value)) {
                    // Block leading space
                    if (value.startsWith(" ")) return;

                    // Block only spaces
                    if (value.trim().length === 0 && value.length > 0) return;
                    setFieldValue(MEMBER_PROFILE_CREATE.NAME, value);
                    handleChange(e);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            placeholder="Email"
            label="Email"
            type="email"
            name={MEMBER_PROFILE_CREATE.EMAIL_ADDRESS}
            value={values[MEMBER_PROFILE_CREATE.EMAIL_ADDRESS]}
            onChange={(e) => {
              const { value } = e.target;
              // Allow blank OR valid email characters (no spaces allowed)
              const emailCharRegex = REGEX.EMAIL_ALLOWED_CHARS;
              if (value === "" || emailCharRegex.test(value)) {
                handleChange(e);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          {/* <InputField
            required
            placeholder="Phone Number"
            label="Phone No."
            type="text"
            name={MEMBER_PROFILE_CREATE.CONTACT_NUMBER}
            value={values[MEMBER_PROFILE_CREATE.CONTACT_NUMBER]}
            onChange={handleChange}
            inputProps={{
              minLength: 10,
              maxLength: 10,
            }}
          /> */}
          <InputField
            required
            placeholder="Phone Number"
            label="Phone No."
            type="text"
            name={MEMBER_PROFILE_CREATE.CONTACT_NUMBER}
            value={values[MEMBER_PROFILE_CREATE.CONTACT_NUMBER] || ""}
            onChange={(e) => {
              const { value } = e.target;
              // OLD (kept for future reference): const regex = /^[0-9]*$/;
              const regex = REGEX.DIGITS_ONLY;

              if (regex.test(value)) {
                setFieldValue(MEMBER_PROFILE_CREATE.CONTACT_NUMBER, value);
                handleChange(e);
              }
            }}
            inputProps={{
              minLength: 10,
              maxLength: 10,
            }}
          />
        </Grid>

        <Grid item xs={5.5} mr="16px">
          <InputField
            placeholder="Date of Birth"
            label="Date of Birth"
            type="date"
            name={MEMBER_PROFILE_CREATE.DATE_OF_BIRTH}
            value={values[MEMBER_PROFILE_CREATE.DATE_OF_BIRTH]}
            onChange={handleChange}
            InputProps={{
              startAdornment: <></>,
            }}
            // disabled={!hasPermission(PERMISSIONS.UPDATE_MEMBER_DOB)}
            // disabled
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.countryName}
            name={MEMBER_PROFILE_CREATE.NATIONALITY_ID}
            options={getOptions(countries, "countryId")}
            inputProps={{ required: true }}
            error={errors[MEMBER_PROFILE_CREATE.NATIONALITY_ID]}
            value={Number(values[MEMBER_PROFILE_CREATE.NATIONALITY_ID])}
            label="Nationality/Country"
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.NATIONALITY_ID,
                selectedValue?.value ?? ""
              );
            }}
          />
        </Grid>
      </Grid>
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={5.5} mr="16px">
          {/* <InputField
            required
            placeholder="Address"
            label="Address"
            type="text"
            name={MEMBER_PROFILE_CREATE.ADDRESS_LINE_1}
            value={values[MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]}
            onChange={handleChange}
          /> */}
          <InputField
            required
            placeholder="Address"
            label="Address"
            type="text"
            name={MEMBER_PROFILE_CREATE.ADDRESS_LINE_1}
            value={values[MEMBER_PROFILE_CREATE.ADDRESS_LINE_1] || ""}
            onChange={(e) => {
              const { value } = e.target;
              // OLD (kept for future reference): const regex = /^[A-Za-z0-9 ,.-/]*$/;
              const regex = REGEX.ADDRESS_ALLOWED;

              if (regex.test(value)) {
                // Block leading space
                if (value.startsWith(" ")) return;

                // Block only spaces
                if (value.trim().length === 0 && value.length > 0) return;
                setFieldValue(MEMBER_PROFILE_CREATE.ADDRESS_LINE_1, value);
                handleChange(e);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          {/* <InputField
            placeholder="Pincode"
            label="Pincode"
            type="text"
            name={MEMBER_PROFILE_CREATE.PINCODE}
            value={values[MEMBER_PROFILE_CREATE.PINCODE]}
            onChange={handleChange}
            inputProps={{
              maxLength: 6,
            }}
          /> */}
          <InputField
            placeholder="Pincode"
            label="Pincode"
            type="text"
            name={MEMBER_PROFILE_CREATE.PINCODE}
            value={values[MEMBER_PROFILE_CREATE.PINCODE] || ""}
            onChange={(e) => {
              const { value } = e.target;
              // OLD (kept for future reference): const regex = /^[0-9]*$/;
              const regex = REGEX.DIGITS_ONLY;

              if (regex.test(value)) {
                setFieldValue(MEMBER_PROFILE_CREATE.PINCODE, value);
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 6,
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.stateName}
            label="State"
            name={MEMBER_PROFILE_CREATE.STATE}
            options={getOptions(states, "stateId")}
            error={errors[MEMBER_PROFILE_CREATE.STATE]}
            value={values[MEMBER_PROFILE_CREATE.STATE]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.STATE, "");
                setCities([]);
              } else {
                setFieldValue(MEMBER_PROFILE_CREATE.STATE, selectedValue.value);
                setCities(selectedValue.cities);
              }
              setFieldValue(MEMBER_PROFILE_CREATE.CITY, "");
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.cityName}
            label="City"
            name={MEMBER_PROFILE_CREATE.CITY}
            options={getOptions(cities, "cityId")}
            error={errors[MEMBER_PROFILE_CREATE.CITY]}
            value={values[MEMBER_PROFILE_CREATE.CITY]}
            disabled={!values[MEMBER_PROFILE_CREATE.STATE]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.CITY, "");
              } else {
                setFieldValue(MEMBER_PROFILE_CREATE.CITY, selectedValue.value);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Division"
            name={MEMBER_PROFILE_CREATE.DIVISION}
            options={getOptions(divisions, "divisionId")}
            error={errors[MEMBER_PROFILE_CREATE.DIVISION]}
            value={values[MEMBER_PROFILE_CREATE.DIVISION]}
            // disabled={values[MEMBER_PROFILE_CREATE.DIVISION]}
            inputProps={{ required: true }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.DIVISION, "");
                setSubDivisions([]);
              } else {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.DIVISION,
                  selectedValue.value
                );
                setSubDivisions(selectedValue.subDivisions);
              }
              setFieldValue(MEMBER_PROFILE_CREATE.SUB_DIVISION_F, "");
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => getSubDivisionDisplayName(option.name)}
            label="Sub Division"
            name={MEMBER_PROFILE_CREATE.SUB_DIVISION_F}
            options={getOptions(subDivisions, "divisionId")}
            error={errors[MEMBER_PROFILE_CREATE.SUB_DIVISION_F]}
            value={values[MEMBER_PROFILE_CREATE.SUB_DIVISION_F]}
            // disabled={values[MEMBER_PROFILE_CREATE.DIVISION]}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(MEMBER_PROFILE_CREATE.SUB_DIVISION_F, "");
              } else {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.SUB_DIVISION_F,
                  selectedValue.value
                );
              }
            }}
          />
        </Grid>
        {values[MEMBER_PROFILE_CREATE.DIVISION] === 52 ||
        values[MEMBER_PROFILE_CREATE.DIVISION] === 53 ? (
          <>
            <Grid item xs={5.5} mr="16px">
              <InputField
                required
                label="Parent's Contact Number"
                name={MEMBER_PROFILE_CREATE.PARENT_CONTACT_NUMBER}
                value={values[MEMBER_PROFILE_CREATE.PARENT_CONTACT_NUMBER]}
                onChange={handleChange}
                error={errors[MEMBER_PROFILE_CREATE.PARENT_CONTACT_NUMBER]}
                inputProps={{
                  maxLength: 10,
                }}
              />
            </Grid>
            <Grid item xs={5.5}>
              <InputField
                label="Parent's Email Address"
                name={MEMBER_PROFILE_CREATE.PARENT_EMAIL_ADDRESS}
                value={values[MEMBER_PROFILE_CREATE.PARENT_EMAIL_ADDRESS]}
                error={errors[MEMBER_PROFILE_CREATE.PARENT_EMAIL_ADDRESS]}
                onChange={handleChange}
              />
            </Grid>
          </>
        ) : null}

        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            label="Profession"
            variant="standard"
            value={values[MEMBER_PROFILE_CREATE.PROFESSION]}
            name={MEMBER_PROFILE_CREATE.PROFESSION}
            error={errors[MEMBER_PROFILE_CREATE.PROFESSION]}
            getOptionLabel={(option) => option.profession}
            options={getOptions(profession, "professionsId")}
            // inputProps={{ required: true }}
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.PROFESSION,
                selectedValue?.value ?? ""
              );
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            placeholder="Remark"
            label="Remark"
            type="text"
            name={MEMBER_PROFILE_CREATE.REMARK}
            value={values[MEMBER_PROFILE_CREATE.REMARK]}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={5.5} mr="16px">
          {/* <InputField
            required
            label="Introducer's Name"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]}
            onChange={handleChange}
          /> */}
          <InputField
            required
            label="Introducer's Name"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME] || ""}
            onChange={(e) => {
              const { value } = e.target;
              // OLD (kept for future reference): const regex = /^[A-Za-z ]*$/;
              const regex = REGEX.NAME_ALPHA_SPACE;

              if (regex.test(value)) {
                // Block leading space
                if (value.startsWith(" ")) return;

                // Block only spaces
                if (value.trim().length === 0 && value.length > 0) return;
                setFieldValue(MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME, value);
                handleChange(e);
              }
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          {/* <InputField
            required
            label="Introducer's Contact Number"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER]}
            onChange={handleChange}
            inputProps={{
              maxLength: 10,
            }}
          /> */}
          <InputField
            required
            label="Introducer's Contact Number"
            type="text"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER}
            value={
              values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER] || ""
            }
            onChange={(e) => {
              const { value } = e.target;
              // OLD (kept for future reference): const regex = /^[0-9]*$/;
              const regex = REGEX.DIGITS_ONLY;

              if (regex.test(value)) {
                setFieldValue(
                  MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER,
                  value
                );
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 10, // Indian mobile number length
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Introducer's Email Address"
            type="email"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL}
            value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL]}
            onChange={(e) => {
              const { value } = e.target;
              // Allow blank OR valid email characters (no spaces allowed)
              const emailCharRegex = REGEX.EMAIL_ALLOWED_CHARS;
              if (value === "" || emailCharRegex.test(value)) {
                handleChange(e);
              }
            }}
          />
        </Grid>
      </Grid>

      {/* <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={5.5} mr="16px">
          <Typography
            style={{
              fontSize: 12,
              color: " #8F92A1",
              fontWeight: 700,
            }}
          >
            Do you want to dit the name of the introducer details?
          </Typography>
          <Box sx={{ pt: "0.8rem" }}>
            <SwitchButton
              value={toggle}
              handleChange={(e) => {
                settoggle(e.target.checked);
                setFieldValue(MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME, "");
                setFieldValue(MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL, "");
                setFieldValue(
                  MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER,
                  ""
                );
                setFieldValue(MEMBER_PROFILE_CREATE.INTRODUCED_BY, "");
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={5.5}>
          {toggle ? (
            <CustomAutoComplete
              required
              api={IntroductionForm.searchMembers}
              placeholder="Search an introducer"
              name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
              setFieldValue={setFieldValue}
              error={errors[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]}
              label="Introducer's Name"
              optionLabelId="fullName"
              optionValueId="fullName"
              withParam="memberName"
              selectedValue={(val) => {
                if (val.fullName) {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME,
                    String(val.fullName)
                  );
                }

                if (val.emailId) {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL,
                    String(val.emailId)
                  );
                }

                if (val.mobileNumber) {
                  setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER,
                    String(val.mobileNumber)
                  );
                }
              }}
              isServerSide
              value={values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]}
              options={[]}
            />
          ) : (
            <InputField
              required
              label="Introducer's Name"
              name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME}
              onChange={handleChange}
              value={
                values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME] ||
                (toggle !== true
                  ? setFieldValue(
                      MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME,
                      introducerName
                    )
                  : " ")
              }
              // disabled
            />
          )}
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            label="Introducer Contact Number"
            required
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER}
            value={
              values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER] ||
              (toggle !== true
                ? setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER,
                    friendProfile.introducerMobileNumber
                  )
                : "")
            }
            onChange={handleChange}
            inputProps={{
              maxLength: 10,
            }}
            disabled={toggle}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Introducer Email Address"
            name={MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL}
            value={
              values[MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL] ||
              (toggle !== true
                ? setFieldValue(
                    MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL,
                    friendProfile.introducerEmail
                  )
                : "")
            }
            onChange={handleChange}
            disabled={toggle}
          />
        </Grid>
      </Grid> */}
      <Grid
        container
        rowSpacing={6}
        style={{
          padding: "32px 16px",
          borderBottom: "1px solid #8F92A133",
        }}
      >
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={5.5}>
              <Typography variant="title2">Organization Structure</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            label="Area"
            placeholder="Area"
            name={MEMBER_PROFILE_CREATE.AREA_NAME}
            value={values[MEMBER_PROFILE_CREATE.AREA_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Cluster"
            placeholder="Cluster"
            name={MEMBER_PROFILE_CREATE.CLUSTER_NAME}
            value={values[MEMBER_PROFILE_CREATE.CLUSTER_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Zone"
            placeholder="Zone"
            name={MEMBER_PROFILE_CREATE.ZONE_NAME}
            value={values[MEMBER_PROFILE_CREATE.ZONE_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <InputField
            label="Region"
            placeholder="Region"
            name={MEMBER_PROFILE_CREATE.REGION_NAME}
            value={values[MEMBER_PROFILE_CREATE.REGION_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5}>
          <InputField
            label="Chapter"
            placeholder="Chapter"
            name={MEMBER_PROFILE_CREATE.CHAPTER_NAME}
            value={values[MEMBER_PROFILE_CREATE.CHAPTER_NAME]}
            onChange={handleChange}
            disabled={!isHelpDesk || !isHelpDeskAdmin}
          />
        </Grid>
        <Grid item xs={5.5} mr="16px">
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            name={MEMBER_PROFILE_CREATE.DISTRICT}
            options={getOptions(district, "structureId")}
            inputProps={{ required: true }}
            error={errors[MEMBER_PROFILE_CREATE.DISTRICT]}
            value={Number(values[MEMBER_PROFILE_CREATE.DISTRICT])}
            label="District"
            disabled={!isHelpDesk || !isHelpDeskAdmin}
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.DISTRICT,
                selectedValue?.value ?? ""
              );
            }}
          />
        </Grid>
        <Grid item xs={5.5}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            name={MEMBER_PROFILE_CREATE.BLOCK}
            options={getOptions(block, "structureId")}
            inputProps={{ required: true }}
            error={errors[MEMBER_PROFILE_CREATE.BLOCK]}
            value={Number(values[MEMBER_PROFILE_CREATE.BLOCK])}
            label="Block"
            disabled={
              !isChapterSi && !isDistrictSi && !isHelpDesk && !isHelpDeskAdmin
            }
            onChange={(selectedValue) => {
              setFieldValue(
                MEMBER_PROFILE_CREATE.BLOCK,
                selectedValue?.value ?? ""
              );
            }}
          />
        </Grid>
      </Grid>

      <Box p="16px">
        <Button
          type="submit"
          label="Save Changes"
          style={{
            minWidth: "145px",
            marginRight: "20px",
          }}
        />
        <Button
          label="Cancel"
          variant="outlined"
          style={{
            minWidth: "145px",
          }}
          onClick={onCancel}
        />
      </Box>
    </Box>
  );
}

function FriendProfileForm() {
  const TITLE = "Edit Friend - BSG";
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);
  const [profession, setProfession] = useState([]);

  const { id } = useParams();
  const toast = useContext(ToastAlertContext);
  const friendProfile = useSelector(selectFriendProfile);
  const navigate = useNavigate();
  const [district, setDistrict] = useState([]);
  const [block, setBlock] = useState([]);
  const { isDistrictSi, isChapterSi, isHelpDesk, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);

  // const enableIsEdit = () => {
  //   if ( === "") {
  //     return isEdit === true;
  //   }
  //   return isEdit === false;
  // };

  // const hasPermission = useUserConfig();
  console.log({ id });

  const getDivisions = async () => {
    const response = await IntroductionForm.getDivisions();
    const divisionData = response?.data || [];
    setDivisions(divisionData);

    if (friendProfile?.divisionId) {
      const selectedDivision = divisionData.find(
        (item) => Number(item.divisionId) === Number(friendProfile.divisionId)
      );

      setSubDivisions(selectedDivision?.subDivisions || []);
    }
  };
const validateForm = (values) => {
  const errors = {};

  const selectedDivision = divisions.find(
    (item) =>
      Number(item.divisionId) ===
      Number(values[MEMBER_PROFILE_CREATE.DIVISION])
  );

  if (
    selectedDivision?.subDivisions?.length > 0 &&
    !values[MEMBER_PROFILE_CREATE.SUB_DIVISION_F]
  ) {
    errors[MEMBER_PROFILE_CREATE.SUB_DIVISION_F] =
      "Please select subdivision";

    toast.show(
      "Please select subdivision",
      AlertStatus.ERROR
    );
  }

  return errors;
};
  const getStates = async () => {
    const response = await IntroductionForm.getStates();
    setStates(response.data);

    if (friendProfile.state) {
      const selectedState = response?.data?.find(
        (state) => Number(friendProfile.state) === state.stateId
      );
      console.log({ selectedState, friendProfile, data: response?.data });
      setCities(selectedState.cities);
    }
  };

  const getCountries = async () => {
    const response = await IntroductionForm.getCountries();
    setCountries(response.data);
  };

  const getProfessions = async () => {
    const response = await IntroductionForm.getProfessions();
    setProfession(response.data);
  };

  const introducerName = friendProfile.introducerName?.length
    ? friendProfile.introducerName.split("-")[0]
    : "";
  console.log("introducerName :", introducerName);

  const getAllDistricts = async () => {
    if (friendProfile.chapterId) {
      const response = await IntroductionForm.getDistricts({
        chapterId: friendProfile.chapterId,
      });
      setDistrict(response.data);
    }
  };

  const getAllBlocks = async () => {
    if (friendProfile.districtId) {
      const response = await IntroductionForm.getBlocks({
        districtId: friendProfile.districtId,
      });
      setBlock(response.data);
    }
  };

  useEffect(() => {
    getStates();
    getCountries();
    getDivisions();
    getProfessions();
    getAllDistricts();
    getAllBlocks();
  }, []);

  const onFormSubmit = async (values) => {
    try {
      await Friends.friendUpdate({ friendId: Number(id), ...values }, id);
      setTimeout(() => {
        navigate(-2);
      }, 2500);

      toast.show("Friend Updated Successfully", AlertStatus.SUCCESS);
    } catch (error) {
      toast.show(
        error.message ?? "something went wrong, try again",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };
  return (
    <div>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box style={Styles.headerContainer}>
        {/* <Box style={Styles.headerHeading}>Edit Profile</Box>
        <Box
          style={{
            display: "flex",
            // justifyContent:""
            alignItems: "center",
          }}
        >
          <Box style={Styles.imageView}>RK</Box>
          <Box style={Styles.uploadstyles}>
            <Box>
              <Button
                label="UPLOAD NEW PHOTO"
                style={{
                  width: "195px",
                  opacity: ".5",
                  pointerEvents: "none",
                }}
                disabled
              />
            </Box>
            <Box style={Styles.uploadSubtitle}>
              Allowed PNG or JPEG. Max size of 800K.
            </Box>
          </Box>
        </Box> */}
      </Box>
      <Box
        style={{
          width: "95%",
          margin: "auto",
        }}
      >
        <div style={Styles.card}>
          <Formik
            initialValues={{
              [MEMBER_PROFILE_CREATE.NAME]: friendProfile.fullName,
              [MEMBER_PROFILE_CREATE.EMAIL_ADDRESS]: friendProfile.emailId,
              [MEMBER_PROFILE_CREATE.CONTACT_NUMBER]:
                friendProfile.mobileNumber,
              [MEMBER_PROFILE_CREATE.DATE_OF_BIRTH]: friendProfile.dateOfBirth,
              [MEMBER_PROFILE_CREATE.NATIONALITY_ID]: Number(
                friendProfile.nationalityId
              ),
              [MEMBER_PROFILE_CREATE.ADDRESS_LINE_1]:
                friendProfile.addressLine1,
              [MEMBER_PROFILE_CREATE.STATE]: Number(friendProfile.state),
              [MEMBER_PROFILE_CREATE.CITY]: Number(friendProfile.city),
              [MEMBER_PROFILE_CREATE.PINCODE]: friendProfile.pincode,
              [MEMBER_PROFILE_CREATE.PROFESSION]: friendProfile.profession,
              [MEMBER_PROFILE_CREATE.DIVISION]: friendProfile.divisionId,
              [MEMBER_PROFILE_CREATE.SUB_DIVISION_F]: friendProfile.subdivisionId,
              [MEMBER_PROFILE_CREATE.PARENT_CONTACT_NUMBER]:
                friendProfile.parentsMobileNumber,
              [MEMBER_PROFILE_CREATE.PARENT_EMAIL_ADDRESS]:
                friendProfile.parentsEmailId,
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_NAME]: introducerName,
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_MOBILE_NUMBER]:
                friendProfile.introducerMobileNumber,
              [MEMBER_PROFILE_CREATE.INTRODUCED_BY_EMAIL]:
                friendProfile.introducerEmail,
              [MEMBER_PROFILE_CREATE.AREA_NAME]: friendProfile.areaName,
              [MEMBER_PROFILE_CREATE.CLUSTER_NAME]: friendProfile.clusterName,
              [MEMBER_PROFILE_CREATE.ZONE_NAME]: friendProfile.zoneName,
              [MEMBER_PROFILE_CREATE.REGION_NAME]: friendProfile.regionName,
              [MEMBER_PROFILE_CREATE.CHAPTER_NAME]: friendProfile.chapterName,
              [MEMBER_PROFILE_CREATE.DISTRICT]: friendProfile.districtId,
              [MEMBER_PROFILE_CREATE.BLOCK]: friendProfile.blockId,
            }}
            validate={validateForm}
  validateOnChange={false}
  validateOnBlur={false}
            onSubmit={debounce(onFormSubmit)}
          >
            {({
              values,
              handleChange,
              errors,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <ProfileForm
                  values={values}
                  handleChange={handleChange}
                  errors={errors}
                  handleSubmit={handleSubmit}
                  setFieldValue={setFieldValue}
                  setCities={setCities}
                  states={states}
                  cities={cities}
                  countries={countries}
                  friendProfile={friendProfile}
                  divisions={divisions}
                  subDivisions={subDivisions}
                  profession={profession}
                  setSubDivisions={setSubDivisions}
                  district={district}
                  block={block}
                  isDistrictSi={isDistrictSi}
                  isChapterSi={isChapterSi}
                  isHelpDesk={isHelpDesk}
                  isHelpDeskAdmin={isHelpDeskAdmin}
                  // hasPermission={hasPermission}
                />
              </form>
            )}
          </Formik>
        </div>
      </Box>
    </div>
  );
}

export default FriendProfileForm;
